<div class="animate__animated animate__slideInUp">
    <mat-card>
        <app-lista-finiquitos></app-lista-finiquitos>
    </mat-card>
</div>